import Game from '../Game';
import Sidebar from '../Sidebar';

const App = () =>
  <section>
    <Sidebar />
    <Game />
  </section>;

export default App;



// WEBPACK FOOTER //
// ./src/views/App/index.jsx